import { StaticSiteSourceSelector } from '@/components/form/static-site-source-selector'
import type { FC } from 'react'

type Props = {
  hasVerifiedCard?: boolean
}

export const Source: FC<Props> = ({ hasVerifiedCard }) => (
  <StaticSiteSourceSelector hasVerifiedCard={hasVerifiedCard} />
)
